import { Box, BoxProps } from "@chakra-ui/react";
export function RecentAssessmentIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.1667 15.6875H13.1734M13.174 14V12.3125M16.9167 14C16.9167 16.0711 15.2377 17.75 13.1667 17.75C11.0956 17.75 9.41667 16.0711 9.41667 14C9.41667 11.9289 11.0956 10.25 13.1667 10.25C15.2377 10.25 16.9167 11.9289 16.9167 14Z"
          stroke="currentColor"
          stroke-width="1.25"
          stroke-linecap="round"
        />
        <path
          d="M8.16667 17.3334H7.9394C5.22172 17.3334 3.86289 17.3334 2.91923 16.6685C2.64885 16.478 2.40882 16.2521 2.20642 15.9976C1.5 15.1095 1.5 13.8306 1.5 11.2728V9.15156C1.5 6.68225 1.5 5.44759 1.89078 4.4615C2.51901 2.87623 3.84761 1.62578 5.53197 1.0345C6.57969 0.666708 7.89151 0.666708 10.5152 0.666708C12.0144 0.666708 12.764 0.666708 13.3627 0.876875C14.3252 1.21475 15.0844 1.92929 15.4434 2.83516C15.6667 3.39864 15.6667 4.10416 15.6667 5.51519V9.00004"
          stroke="currentColor"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.5 9C1.5 7.46588 2.74365 6.22222 4.27778 6.22222C4.8326 6.22222 5.4867 6.31944 6.02614 6.1749C6.50543 6.04647 6.8798 5.6721 7.00823 5.1928C7.15277 4.65336 7.05555 3.99926 7.05555 3.44444C7.05555 1.91032 8.29921 0.666667 9.83333 0.666667"
          stroke="currentColor"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}
